// 商品管理番号の決め方（Issue #22）。
//
// 1. `data-product-code` があればそれ（page/2522 の既存の置き方。1ページ1商品）
// 2. 無ければ URL のクエリ `p`（商品ページから案内ページへ飛ばす導線。ChatBan #151）。
//    クエリ名は `data-product-code-param` で変えられる（おちゃのこ側の都合への保険）
//
// ★どちらも整数のみ。数字以外・0以下・int の範囲外は「無い」扱いにして描画しない
//   （Issue #18 の上限と同じ基準）。data 属性が壊れているときはクエリに落ちない —
//   ページの書き方の間違いをクエリで隠さないため。

/** SQL Server の int の上限。server 側 product-lookup.ts と同じ値。 */
const INT_MAX = 2147483647

const DEFAULT_PARAM = 'p'

function parseCode(raw: string | undefined | null): number | null {
  const s = (raw ?? '').trim()
  if (!/^\d{1,10}$/.test(s)) return null
  const n = Number(s)
  return n > 0 && n <= INT_MAX ? n : null
}

export interface ResolvedProductCode {
  code: number
  /** どこから取ったか。ログ用 */
  source: 'attr' | 'query'
}

/**
 * dataset は要素の data-*。search は location.search（`?p=200` の形。空でもよい）。
 * 決められなければ null。
 */
export function resolveProductCode(
  dataset: { productCode?: string; productCodeParam?: string },
  search: string,
): ResolvedProductCode | null {
  const attr = (dataset.productCode ?? '').trim()
  if (attr !== '') {
    const code = parseCode(attr)
    return code === null ? null : { code, source: 'attr' }
  }

  const param = (dataset.productCodeParam ?? '').trim() || DEFAULT_PARAM
  const code = parseCode(new URLSearchParams(search).get(param))
  return code === null ? null : { code, source: 'query' }
}
